import React from "react"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import Button from "../themed-html-components/Button"

function ShowAllButton({ onClick, isActive, t }) {
  return (
    <div className="col-md-12 text-center d-print-none">
      <Button
        text={t(isActive ? "Common.SeeLess" : "Common.SeeAll")}
        onClick={onClick}
        extraClassNames="btn-sm text-center"
      />
    </div>
  )
}

ShowAllButton.propTypes = {
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default translate()(ShowAllButton)



// WEBPACK FOOTER //
// ./src/components/widgets/ShowAllButton.jsx